import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  ListItemButton,
  OutlinedInput,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CUSTOMER } from "../../config/constants";
import { pathContains } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import { setMainNavItem } from "../../stateManagement/reducers/menuReducer";
import { IOrdersState } from "../../stateManagement/reducers/ordersReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";

const Footer = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { activeMembership } = useSelector<IRootReducerT, IOrdersState>(
    (state) => state.orders,
  );

  const title = process.env.REACT_APP_APP_NAME;
  const creatorName = process.env.REACT_APP_CREATOR_NAME;
  const creatorUrl = process.env.REACT_APP_CREATOR_URL;

  const slogan = "Legal Practitioners and Arbitrators";

  const officeAddress = "Suite 7, Law Hub, Ring Road, Ibadan";

  const line1 = "+234 818 856 6937";
  const line2 = "+234 812 999 1303";

  const [email, setEmail] = useState("");

  const quickLinks1 = [
    {
      id: "welcome",
      title: "Home",
      type: "item",
      url: "/welcome",
      userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    },
    {
      id: "products",
      title: "Shop",
      type: "item",
      url: "/products",
      userAuth: false,
    },
    // {
    //   id: "services",
    //   title: "Services",
    //   type: "item",
    //   url: "/services/other-services",
    //   userAuth: false,
    // },
    ...(user?.role?.name === CUSTOMER
      ? [
          {
            id: "orders",
            title: "orders",
            type: "item",
            url: "/orders",
            userAuth: false,
          },
        ]
      : []),
  ];

  const quickLinks2 = [
    {
      id: "about-us",
      title: "About Us",
      type: "item",
      url: "/welcome",
      section: "about-us",
      userAuth: false,
      children: [],
    },
    {
      id: "faq",
      title: "FAQs",
      type: "item",
      url: "/welcome",
      section: "faq",
      userAuth: false,
      children: [],
    },
    {
      id: "contact-us",
      title: "Contact Us",
      type: "item",
      url: "/welcome",
      section: "contact-us",
      userAuth: false,
      children: [],
    },
    // {
    //   id: "terms-and-conditions",
    //   title: "Terms & Conditions",
    //   type: "item",
    //   url: "/terms-and-conditions", //TODO: set route to terms & conditions page
    //   userAuth: false,
    // },
  ];

  const socialMediaData = [
    {
      url: "",
      platform: "X",
      icon: (
        <XIcon sx={{ height: "1.25rem", width: "1.25rem", color: "#2F5042" }} />
      ),
    },
    {
      url: "",
      platform: "Facebook",
      icon: <FacebookIcon sx={{ height: "1.25rem", width: "1.25rem" }} />,
    },
    {
      url: "",
      platform: "Instagram",
      icon: <InstagramIcon sx={{ height: "1.25rem", width: "1.25rem" }} />,
    },
  ];

  const logoHeight = "8rem";
  const LogoImg = styled("img")(() => ({
    position: "relative",
    height: "100%",
    margin: "auto",
  }));

  return (
    <Stack
      alignItems="center"
      sx={{
        backgroundColor: "white !important",
        width: "100%",
        marginTop: "0 !important",
        py: {
          xs: "2rem !important",
          md: "2rem !important",
        },
        pb: "2rem",
        px: "1rem",
        position: "relative",
        zIndex: 1,
      }}
    >
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "1800px !important",
        }}
        justifyContent="space-around"
      >
        <Grid item xs={12} md="auto" spacing={4}>
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "center"}
            spacing={4}
            sx={{
              width: idGreaterThanMd ? undefined : "100%",
            }}
          >
            <Box
              sx={{ display: { xs: "flex", md: "flex" }, height: logoHeight }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  height: idGreaterThanMd ? undefined : "8rem",
                  mx: idGreaterThanMd ? undefined : "auto",
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Typography
              variant="body1"
              sx={{
                mt: "2rem",
                textAlign: { xs: "center", md: "left" },
                color: "#2F5042 !important",
                fontWeight: "400",
                fontSize: "0.75rem !important",
                lineHeight: "1.875rem !important",
                cursor: "pointer",
                maxWidth: "20.125rem",
              }}
              onClick={() => {
                // Encode the address to make it URL-safe
                const encodedAddress = encodeURIComponent(officeAddress);

                // Create the Google Maps URL with the encoded address
                const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

                // Open the Google Maps URL in a new tab
                window.open(googleMapsUrl, "_blank");
              }}
            >
              Thank you for visiting Shop Twenty 9! We’re glad you stopped by,
              and we hope you found exactly what you were searching for.
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={6} md="auto" sx={{ ml: { xs: "0", md: "8rem" } }}>
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                height: logoHeight,
                opacity: "0%",
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"}>
              <Typography
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "#2F5042 !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Quick Links
              </Typography>
              {quickLinks1.map((quickLink, i) => {
                return (
                  <ListItemButton
                    sx={{
                      pl: "0 !important",
                    }}
                    onClick={() => {
                      window.open(quickLink.url, "_self");
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        color: pathContains(location.pathname, quickLink.id)
                          ? "rgba(26, 189, 84, 1) !important"
                          : "#2F5042 !important",
                      }}
                      variant="body1"
                    >
                      {quickLink.title}
                    </Typography>
                  </ListItemButton>
                );
              })}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6} md="auto">
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-end"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                height: logoHeight,
                opacity: "0%",
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"}>
              <Typography
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "#2F5042 !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Quick Links
              </Typography>
              {quickLinks2.map((quickLink, i) => {
                return (
                  <ListItemButton
                    onClick={() => {
                      dispatch(setMainNavItem(quickLink));
                      navigate(quickLink.url, { replace: false });
                    }}
                    sx={{
                      pl: "0 !important",
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        color: pathContains(location.pathname, quickLink.id)
                          ? "rgba(26, 189, 84, 1) !important"
                          : "#2F5042 !important",
                      }}
                      variant="body1"
                    >
                      {quickLink.title}
                    </Typography>
                  </ListItemButton>
                );
              })}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md="auto">
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                height: logoHeight,
                opacity: "0%",
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems="flex-start" spacing={2}>
              <Typography
                sx={{
                  color: "#2F5042 !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Newsletter
              </Typography>
              <Typography
                sx={{
                  color: "#2F5042 !important",
                  fontSize: ".75rem !important",
                }}
                variant="body1"
              >
                Subscribe for the latest updates
              </Typography>
              <OutlinedInput
                id="email-reg"
                type="email"
                value={email}
                name="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                placeholder="Enter your email"
                fullWidth
                error={Boolean(false)}
                sx={{
                  opacity: "100%",
                  borderRadius: "0",
                  border: "1px solid rgba(255, 255, 255, 0.80)",
                  backgroundColor: "rgba(0, 0, 0, 0.30)",
                  color: "#FFF !important",
                  fontStyle: "italic",
                  fontWeight: "500",
                  fontSize: ".75rem",
                  width: "100%",
                  maxWidth: "39.375rem !important",
                  minWidth: "0 !important",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                    color: "#2F5042 !important",
                    maxWidth: "39.375rem !important",
                  },
                  "&::placeholder": {
                    color: "#FFF !important",
                    opacity: 1,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
              />
              <Button
                variant="contained"
                size="large"
                sx={{
                  backgroundColor: "#B89968",
                  border: "solid #D4BB91 1px",
                  my: 2,
                  color: "white",
                  "&:hover": {
                    borderColor: "#2F5042 !important",
                    border: "solid #2F5042 1px",
                  },
                }}
                onClick={() => {}}
              >
                <b>SUBSCRiBE</b>
              </Button>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Container
        sx={{
          marginTop: "2rem",
          width: "100%",
          maxWidth: "1600px !important",
          height: "1px",
          opacity: "0.5",
          background: "#FFF",
        }}
      ></Container>
      <Typography
        color="white"
        textAlign="center"
        variant="h3"
        sx={{
          margin: "0 !important",
          fontSize: "1.125rem !important",
          color: "#2F5042 !important",
          fontWeight: 400,
          pt: {
            xs: "2rem !important",
            md: "2rem !important",
          },
          pb: "2.5rem",
          position: "relative",
          zIndex: "1",
        }}
      >
        Created By{" "}
        <b
          onClick={() => window.open(creatorUrl, "_blank")}
          style={{
            color: "#B89968",
            cursor: "pointer",
            borderBottom: "Solid .0625ren inherit",
          }}
        >
          {creatorName}
        </b>{" "}
        | ALL RIGHTS RESERVED! &copy; {new Date().getFullYear()}
      </Typography>
    </Stack>
  );
};

export default Footer;
